'use strict';
import {UserViewActivity} from './components/UserViewActivity';
import {UserViewChannels} from './components/UserViewChannels';
import {UserViewHome} from './components/UserViewHome';
import {routerConfig} from './router';


/**
 * Module dependencies
 */
const angular = require('angular');

module.exports = angular
  .module('app.user', [])
  .config(routerConfig)
  .value('UserViewActivity', UserViewActivity)
  .value('UserViewChannels', UserViewChannels)
  .value('UserViewHome', UserViewHome)
;



// WEBPACK FOOTER //
// ./src/js/user/index.js